export default __webpack_public_path__ + "static/media/blocked-popup-clue.3597553a.jpg";